import { FormValue } from '@flatsy/types/Applications'
import { Options as ButtonsOptions } from '@flatsy/core/Form/ReactFormHooks/Field/Buttons/Type'
import i18n from '@flatsy/utils/translations'

export const projectWhen = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('as_soon_as_possible'),
      value: FormValue.when.NOW,
    },
    {
      label: i18n.t('less_than_a_month'),
      value: FormValue.when.LTMONTH,
    },
    {
      label: i18n.t('between_1_and_2_months'),
      value: FormValue.when.LTTWOMONTH,
    },
    {
      label: i18n.t('more_than_2_months'),
      value: FormValue.when.GTTWOMONTH,
    },
  ]
}

/**
 * Field : household_type
 */
export const projectWho = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('alone'),
      value: FormValue.who.SINGLE,
    },
    {
      label: i18n.t('with_roommates'),
      value: FormValue.who.SHARED,
    },
    {
      label: i18n.t('as_a_couple'),
      value: FormValue.who.COUPLE,
    },
    {
      label: i18n.t('family'),
      value: FormValue.who.FAMILY,
    },
  ]
}

/**
 * Field : union_type
 */
export const projectUnionType = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('married'),
      value: FormValue.unionType.married,
    },
    {
      label: i18n.t('civil_union'),
      value: FormValue.unionType.pacs,
    },
    {
      label: i18n.t('cohabitation'),
      value: FormValue.unionType.union,
    },
  ]
}

/**
 * Field : household_adults
 */
export const projectAdults = (): ButtonsOptions[] => {
  return [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6+',
      value: '6',
    },
  ]
}

/**
 * Field : household_children
 */
export const projectChildren = (): ButtonsOptions[] => {
  return [
    {
      label: '0',
      value: '0',
    },
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6+',
      value: '6',
    },
  ]
}
